import { CMI5 } from '../../const';

//----------------------------------------------------------------------------------------------------------------------
export let getActivityIcon = activityType => {
  switch (activityType) {
    case CMI5.ACTIVITY_TYPE.UNIT:
      return 'directory';
    case CMI5.ACTIVITY_TYPE.LESSON:
      return 'blank-paper-sheet';
    case CMI5.ACTIVITY_TYPE.SINGLE_CHOICE:
      return 'single-choice';
    case CMI5.ACTIVITY_TYPE.MATRIXSINGLECHOICE:
      return 'matrix-single-choice';
    case CMI5.ACTIVITY_TYPE.MULTIPLE_CHOICE:
      return 'multiple-choice';
    case CMI5.ACTIVITY_TYPE.MATRIXMULTIPLECHOICE:
      return 'matrix-multiple-choice';
    case CMI5.ACTIVITY_TYPE.IMAGE_MULTIPLE_CHOICE:
      return 'img-multiple-choice';
    case CMI5.ACTIVITY_TYPE.ESSAY:
      return 'essay';
    case CMI5.ACTIVITY_TYPE.VIDEO:
      return 'play-video';
    case CMI5.ACTIVITY_TYPE.AUDIO:
      return 'audio-headphones';
    case CMI5.ACTIVITY_TYPE.TEXTENTRY:
      return 'fill-gaps';
    case CMI5.ACTIVITY_TYPE.INLINE_CHOICE:
      return 'drop-down';
    case CMI5.ACTIVITY_TYPE.DRAGANDDROP:
      return 'drag-drop';
    case CMI5.ACTIVITY_TYPE.MATCHINGPAIR:
      return 'icon-pairs-activity';
    case CMI5.ACTIVITY_TYPE.DISCUSSION:
      return 'dialogue-balloon';
    case CMI5.ACTIVITY_TYPE.NOINTERACTIVE:
      return 'no-interactive';
    case CMI5.ACTIVITY_TYPE.LIKERT:
      return 'smiling-face';
    case CMI5.ACTIVITY_TYPE.DRAW:
      return 'edit-pencil';
    case CMI5.ACTIVITY_TYPE.RESPONSE_IN_IMAGE:
      return 'photography-frame';
    case CMI5.ACTIVITY_TYPE.MATHFORMULAE:
      return 'math-formulae';
    case CMI5.ACTIVITY_TYPE.VIDEO_RECORDING:
      return 'multimedia-music-player-play-button';
    case CMI5.ACTIVITY_TYPE.AUDIO_RECORDING:
      return 'voice-recording';
    case CMI5.ACTIVITY_TYPE.UPLOAD_FILE:
      return 'school-paper-clip';
    case CMI5.ACTIVITY_TYPE.DRAGGINGIMAGE:
      return 'image-draggable';
    case CMI5.ACTIVITY_TYPE.SCORM:
      return 'scorm-activity';
    case CMI5.ACTIVITY_TYPE.PASSWORD:
      return 'password-activity';
    default:
      return 'question-mark-circle';
  }
};
export let ASSESSABLE_TYPES = [
  CMI5.ACTIVITY_TYPE.SINGLE_CHOICE,
  CMI5.ACTIVITY_TYPE.MULTIPLE_CHOICE,
  CMI5.ACTIVITY_TYPE.INLINE_CHOICE,
  CMI5.ACTIVITY_TYPE.ESSAY,
  CMI5.ACTIVITY_TYPE.MATCHINGPAIR,
  CMI5.ACTIVITY_TYPE.TEXTENTRY,
  CMI5.ACTIVITY_TYPE.DRAGANDDROP,
  CMI5.ACTIVITY_TYPE.BINARYCHOICE,
  CMI5.ACTIVITY_TYPE.DISCUSSION,
  CMI5.ACTIVITY_TYPE.NOINTERACTIVE,
  CMI5.ACTIVITY_TYPE.MATRIXSINGLECHOICE,
  CMI5.ACTIVITY_TYPE.MATRIXMULTIPLECHOICE,
  CMI5.ACTIVITY_TYPE.SCORM,
  CMI5.ACTIVITY_TYPE.DRAW,
  CMI5.ACTIVITY_TYPE.LIKERT,
  CMI5.ACTIVITY_TYPE.RESPONSE_IN_IMAGE,
  CMI5.ACTIVITY_TYPE.AUDIO_RECORDING,
  CMI5.ACTIVITY_TYPE.VIDEO_RECORDING,
  CMI5.ACTIVITY_TYPE.UPLOAD_FILE,
  CMI5.ACTIVITY_TYPE.DRAGGINGIMAGE,
  CMI5.ACTIVITY_TYPE.MATHFORMULAE,
  CMI5.ACTIVITY_TYPE.PASSWORD
];
